import {TypeaheadService} from '../typeahead/typeahead.service'
import * as $ from 'jquery';


export class SiteSearchCommon {

    public static init() {
        $('input.site-search').each((i, inp: HTMLInputElement) => {
            TypeaheadService.setupTypeaheadRemote(inp, '/search/suggest?Keyword=%QUERY',
                'objects', 'title', false,
                result => {
                    let start = $('h1.search-keyword').text().indexOf('„');
                    if (start > -1) {
                        $('h1.search-keyword').text($('h1.search-keyword').text().substr(0, start + 1) + inp.value + '“');
                    }
                    start = location.href.indexOf('search?q=');
                    if (start > -1)
                        window.history.pushState({}, "", location.href.substr(0, start + 9) + inp.value);
                }, null,
                data => {
                    let query = inp.value;
                    let start = data.title.toLowerCase().indexOf(query.toLowerCase());
                    if (start > -1) {
                        return `<div class="product-select-option">
                                    ` + (data.type ? `<span class="type">${data.type}</span>`: '') + `<a href="${data.link}">${data.title.substr(0, start) + '<strong>' + data.title.substr(start, query.length) + '</strong>' + data.title.substr(start + query.length)}</a></div>`;
                    } else {
                        return `<div class="search-select-option">` + (data.type ? `<span class="type">${data.type}</span>`: '') + `<a href="${data.link}">${data.title}</a></div>`

                    }
                }, 'No matching products');
        });
    }

}
